module.exports = __webpack_public_path__ + "static/media/0_2019_08_17.59545008.jpg";